import Config from '@config';
import { CACHE_EXPIRATION_TIME } from '@gasbi/shared/common/features/constants';

import { injectHouseholdsSlice } from '@/app/householdsApi';

import {
  AddGasConsumingEquipmentRequestBody,
  GasConsumingEquipmentFullReadModel,
  UpdateGasConsumingEquipmentRequestBody,
} from './types';

export const transformGasConsumingEquipment = (
  data: GasConsumingEquipmentFullReadModel,
) => ({
  ...data,
  name: [data.equipmentGroupName, data.equipmentTypeName, data.factoryNumber]
    .filter(Boolean)
    .join(' '),
});

export const gasConsumingEquipmentsApi = injectHouseholdsSlice({
  baseUrl: `${Config.VITE_API_URL}/metering-points`,
  tagTypes: ['GasConsumingEquipments', 'GasConsumingEquipment'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getGasConsumingEquipmentById: builder.query<
      GasConsumingEquipmentFullReadModel,
      { meteringPointId: string; gasConsumingEquipmentId: string }
    >({
      query: ({ meteringPointId, gasConsumingEquipmentId }) => ({
        url: `/${meteringPointId}/gas-consuming-equipments/${gasConsumingEquipmentId}`,
      }),
      transformResponse: transformGasConsumingEquipment,
      providesTags: (_, __, { gasConsumingEquipmentId }) => [
        'GasConsumingEquipment',
        { type: 'GasConsumingEquipments', id: gasConsumingEquipmentId },
      ],
    }),
    addGasConsumingEquipment: builder.mutation<
      void,
      AddGasConsumingEquipmentRequestBody
    >({
      query: data => ({
        url: `/${data.meteringPointId}/gas-consuming-equipments`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['GasConsumingEquipments'],
    }),
    updateGasConsumingEquipment: builder.mutation<
      void,
      UpdateGasConsumingEquipmentRequestBody
    >({
      query: data => ({
        url: `/${data.meteringPointId}/gas-consuming-equipments/${data.id}`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: (_, __, { gasConsumingEquipmentId }) => [
        'GasConsumingEquipment',
        { type: 'GasConsumingEquipments', id: gasConsumingEquipmentId },
      ],
    }),
  }),
});

export const {
  useGetGasConsumingEquipmentByIdQuery,
  useAddGasConsumingEquipmentMutation,
  useUpdateGasConsumingEquipmentMutation,
} = gasConsumingEquipmentsApi;
